import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { PalantirButtonComponent } from '../button/button.component';
import { PalantirContentComponent } from '../content/content.component';
import { PalantirDialogComponent } from '../dialog/dialog.component';
import { PalantirIconComponent } from '../icon/icon.component';
import { PalantirTextComponent } from '../text/text.component';
import { PalantirCarouselComponent } from './carousel.component';
import { PalantirCarouselService } from './carousel.service';

@NgModule({
  imports: [
    CommonModule,
    PalantirIconComponent,
    PalantirDialogComponent,
    PalantirContentComponent,
    PalantirTextComponent,
    PalantirButtonComponent,
  ],
  providers: [PalantirCarouselService],
  declarations: [PalantirCarouselComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PalantirCarouselModule {}
